export default {"src":"/_next/static/media/Estelle.f92b50f1.svg","height":45,"width":44,"blurWidth":0,"blurHeight":0};